import type { ReactNode } from 'react';
import { BillReviewStage } from './BillReviewStage.js';

/**
 * The finance approval of a forwarded bill, once its accounts check has passed.
 * Approving it issues the financial certificate and the payment eligibility in
 * the same act, so the bill reaches the payment maker's queue.
 */
export function FinanceReviewPage(): ReactNode {
  return (
    <BillReviewStage
      stage="finance"
      checks={['financialLiabilityOk', 'budgetAvailabilityOk', 'commercialApprovalOk', 'accountsApprovalOk', 'policyComplianceOk']}
      decisions={['APPROVE', 'REJECT', 'RETURN', 'HOLD', 'ESCALATE']}
    />
  );
}
